import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const init = () => {
  Fancybox.bind('[data-fancybox="video"]', {
    Thumbs: {
      autoStart: true,
    },
    Toolbar: {
      display: ["zoom", "slideShow", "thumbs", "close"],
    },
  });
};

init();
